import React from 'react';
import { banner } from '../assets/assets';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative w-full py-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src={banner} 
          alt="Person typing on keyboard" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gray-900 bg-opacity-60"></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <h2 className="text-white text-2xl md:text-4xl font-medium mb-3 md:mb-6">
          Ready to Get Started ?
        </h2>
        
        <p className="text-white text-[12px] md:text-lg max-w-2xl mx-auto mb-8 md:mb-12">
          Create an account, it's quick, simple and free, Select services 
          you want, get connected to our experts and get your job done 
          as fast as possible.
        </p>
        
        <a href={"/clients/signup"} className="bg-white text-[#174568] font-medium py-3 px-8 rounded-md hover:bg-gray-100 transition-colors">
          Get Started it's Free
        </a>
      </div>
    </section>
  );
};

export default CTASection;